import React, { FC, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'

import ReactVerificationCodeInput from 'react-verification-code-input'
import 'react-phone-input-2/lib/style.css'

import styles from './styles.module.scss'

interface IProps {
  onChange: (value: string) => void
  fields?: number
}

export const ReactCodeInput: FC<IProps> = ({ onChange, fields= 6 }) => {
  const [placeholder] = useState(Array.from({ length: fields }, (_) => ('-')))

  return (
    <ReactVerificationCodeInput
      type={'number'}
      fields={fields}
      onChange={onChange}
      fieldWidth={60}
      fieldHeight={80}
      autoFocus={true}
      placeholder={placeholder}
      className={styles.reactVerificationCodeInputContainer}
    />
  )
}
